declare let ApexCharts: any;

namespace Controlli {
    export namespace ChartsGlobal {
        export function DestroyChart(idChart: string) { ApexCharts.exec(idChart, 'destroy'); }

        export function RenderChart(divIdValue: string, options: Object) { new ApexCharts(document.getElementById(divIdValue), options).render(); }

        export class BaseChart {
            ChartId: string;
            ChartHeight: number;
            Type: string;
            DivIdValue: string;
            DefaultLocal: string;
            DefaultRegion: string;
            Colors: Array<string>;
            Labels: Array<string>;
            PlotSize: number;
            constructor(baseChart?: BaseChart) {
                if (baseChart) {
                    this.ChartId = baseChart.ChartId;
                    this.ChartHeight = baseChart.ChartHeight;
                    this.Type = baseChart.Type;
                    this.DivIdValue = baseChart.DivIdValue;
                    this.DefaultLocal = baseChart.DefaultLocal;
                    this.DefaultRegion = baseChart.DefaultRegion;
                    this.Colors = baseChart.Colors;
                    this.Labels = baseChart.Labels;
                    this.PlotSize = baseChart.PlotSize;
                }
            }
        }
    }
}
